var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagGer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2371 3341)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_GER",
    transform: "translate(-2371 -3341)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_alemanha",
    transform: "translate(2350.194 3341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_541",
    "data-name": "Ret\\xE2ngulo 541",
    width: 102.838,
    height: 19.989,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_542",
    "data-name": "Ret\\xE2ngulo 542",
    width: 102.838,
    height: 19.999,
    transform: "translate(0 19.989)",
    fill: "#e1001f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_543",
    "data-name": "Ret\\xE2ngulo 543",
    width: 102.838,
    height: 20.001,
    transform: "translate(0 39.987)",
    fill: "#f6d928"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGer);
export default __webpack_public_path__ + "static/media/flag_GER.ea780974597620d1854c605f0a7966b6.svg";
export { ForwardRef as ReactComponent };